/** @jsx jsx */
import _ from 'lodash';
import { jsx } from '@emotion/core';

const imageCss = (isSmall: boolean) => ({
  display: 'inline-block',
  width: isSmall ? 50 : 60,
});

const svgCss = (props: PaymentMethodImageProps) => ({
  display: 'block',
  height: 'inherit',
  opacity: props.isDisabled ? 0.4 : 1.0,
  width: 'inherit',
});

type PaymentMethodImageProps = {
  /** Image type to show */
  imageType: string;
  /** Show image greyed out */
  isDisabled?: boolean;
  /** Show small version of image */
  isSmall?: boolean;
};

const PaymentMethodImage: React.FC<PaymentMethodImageProps> = props => {
  const { imageType, isSmall = false } = props;

  let ImageSvg;

  try {
    ImageSvg = require(`./images/${_.kebabCase(imageType)}.svg`).default;
  } catch (e) {
    ImageSvg = require('./images/unknown.svg').default;
  }

  return (
    <span css={imageCss(isSmall)}>
      <ImageSvg css={svgCss(props)} />
    </span>
  );
};

export default PaymentMethodImage;
